module.exports = __webpack_public_path__ + "static/media/Logo.94e63088.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Logo.jpg
// module id = 321
// module chunks = 0